import React from 'react';
import pluralize from 'pluralize';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { getTranslation } from 'domain-model';
import IconX from '../icons/IconX';

export function getDisplayValue(key, value) {
  if (value === true) {
    return 'Ja';
  }
  if (value === false) {
    return 'Nej';
  }
  return getTranslation(`article.${pluralize(key)}`, value);
}

export const ActiveButton = ({ filterKey, value, onClick }) => (
  <div
    className="animated fadeIn mt-1 fs-6 "
    onClick={onClick}
    onKeyDown={onClick}
    tabIndex="0"
    role="button"
  >
    <Button
      block
      color="light"
      className="text-start text-dark ps-2 pe-1 activeFilterButton"
    >
      {getDisplayValue(filterKey, value)}

      <span className="close-rotate float-end">
        <IconX height="10" />
      </span>
    </Button>
  </div>
);
ActiveButton.propTypes = {
  filterKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
};
ActiveButton.defaultProps = {
  filterKey: '',
};

export const InactiveButton = ({ filterKey, value, count, onClick }) => {
  return (
    <div onClick={onClick} onKeyDown={onClick} tabIndex="0" role="button">
      <h6
        color="Link"
        className="ps-2 pe-1 text-muted link-animated link-animated-light fw-light filter-button-inactive"
      >
        {getDisplayValue(filterKey, value)}
        {_.isNumber(count) && <small className="float-end">({count})</small>}
      </h6>
    </div>
  );
};
InactiveButton.propTypes = {
  filterKey: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

InactiveButton.defaultProps = {
  filterKey: '',
};
